// src/components/Footer.js
import logo from '../assets/logo.png';

const COLS = {
  Navigate: [
    { id: 'home',           label: 'Home'           },
    { id: 'about',          label: 'About Us'        },
    { id: 'how-it-works',   label: 'How It Works'    },
    { id: 'for-citizens',   label: 'For Citizens'    },
    { id: 'for-businesses', label: 'For Businesses'  },
  ],
  Legal: [
    { id: 'privacy',         label: 'Privacy Policy' },
    { id: 'terms',           label: 'Terms & Conditions' },
    { id: 'delete-request',  label: 'Delete My Data' },
  ],
  Contact: [
    { id: 'contact',        label: 'Get in Touch' },
    { id: null,             label: 'yojanasaathi@gmail.com' }
  ],
};

export default function Footer({ go }) {
  return (
    <footer className="footer">
      <div className="flag" style={{ height: 4 }}><span /><span /><span /></div>
      <div className="grid">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
            <img src={logo} alt="YojanaSaathi" className="brand-logo" />
            <div>
              <div className="brand-name">YojanaSaathi</div>
              <div className="brand-sub-f">योजना साथी</div>
            </div>
          </div>
          <p className="brand-desc">Helping citizens and businesses across India find and apply for the government schemes they deserve — completely free.</p>
          <div className="tricolor">
            <span style={{ background: '#FF9933' }} />
            <span style={{ background: '#fff' }} />
            <span style={{ background: '#138808' }} />
          </div>
        </div>
        {Object.entries(COLS).map(([title, items]) => (
          <div key={title} className="col">
            <h5>{title}</h5>
            <ul>
              {items.map(item => (
                <li key={item.label}>
                  {item.id ? (
                    <button onClick={() => go(item.id)}>{item.label}</button>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="bottom">
        <span>© 2026 YojanaSaathi. All rights reserved.</span>
        <span>Independent organization · Not affiliated with the Government of India.</span>
      </div>
    </footer>
  );
}